import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import {
  loadObjectAccess,
  saveObjectAccess,
} from "src/business/access/apiAccess";
import { ZObjectAccess } from "src/business/access/ZObjectAccess";
import { ZSpecAccess } from "src/business/access/ZSpecAccess";
import { loadCatalog } from "src/business/catalog/apiCatalog";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { SpecificationsAccessStore } from "src/business/specification/SpecificationsAccessEditor";
import { RemoteData } from "src/common/RemoteData";
import { PageUrl } from "src/routes/PageUrl";

export type CatalogAccessPageData = {
  catalog: ZCatalog;
  accessInfo: ZObjectAccess;
  accessStore: SpecificationsAccessStore;
};

export const catalogAccessStore = makeAutoObservable({
  async init(catalogId: string) {
    try {
      this.setData({ status: "wait" });
      const [catalog, accessInfo] = await Promise.all([
        loadCatalog(catalogId),
        loadObjectAccess("catalog", catalogId),
      ]);
      const save = async (views: ZSpecAccess[]): Promise<ZSpecAccess[]> => {
        const res = await saveObjectAccess("catalog", catalogId, { views });
        return res.views;
      };
      const accessStore = new SpecificationsAccessStore(accessInfo.views, save);
      const result = { catalog, accessInfo, accessStore };
      this.setData({ status: "ready", result });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  data: { status: "none" } as RemoteData<CatalogAccessPageData>,
  setData(newData: RemoteData<CatalogAccessPageData>) {
    this.data = newData;
  },
  get crumbs() {
    const items: BreadcrumbItem[] = [
      { title: "Каталоги", page: PageUrl.managementCatalogs },
    ];
    const { data } = this;
    if (data.status === "ready") {
      const { catalog } = data.result;
      items.push({
        title: catalog.name,
        page: PageUrl.managementCatalogEdit,
        params: { id: catalog.id },
      });
      items.push({ title: "Представление" });
    }
    return items;
  },
});
